/** enum of product metric event */
export enum ProductMetricEvent {
  USER_CLICK_FORGET_PASSWORD = 'user_click_forget_password',
  USER_CLICK_CREATE_ACCOUNT = 'user_click_create_account',
  USER_CLICK_ENTER = 'user_click_enter',
  USER_CLICK_WANT_GET_LETTERS = 'user_click_want_get_letters',
  USER_CLICK_CONTINUE_ON_ACCOUNT_CREATION = 'user_click_continue_on_account_creation',
  USER_CLICK_FORGET_EMAIL = 'user_click_forget_email',
  USER_CLICK_BUTTON_RECOVER_PASSWORD = 'user_click_button_recover_password',
  USER_CLICK_BUTTON_PAY = 'user_click_button_pay',
  USER_CLICK_CONNECT_SERVER = 'user_click_connect_server',
  USER_CLICK_DIGITAL_OCEAN = 'user_click_digital_ocean',
  USER_CLICK_HAS_SERVER = 'user_click_has_server',
  USER_CLICK_HAS_DEMO = 'user_click_has_demo',
  USER_CHOOSE_COUNTRY = 'user_choose_country',
  USER_CLICK_COUNTRY_QUESTION = 'user_click_country_question',
  USER_CHOOSE_PAYER_TYPE = 'user_choose_payer_type',
  USER_CLICK_LINK_CHECK_VAT = 'user_click_link_check_vat',
  USER_CLICK_BUTTON_CHECK_ORG_DATA = 'user_click_button_check_org_data',
  SUCCESS_PAYMENT = 'success_payment',
  USER_CLICK_CHKBX_SAME_ADDRESSES = 'user_click_chkbx_same_adreses',
  USER_CLICK_USE_OWN_SERVER = 'user_click_use_my_server',
  USER_CLICK_PAY_ON_DEMO_EXPIRED = 'user_click_pay_on_demo_expired',
  USER_SIGNED_UP_FROM_TRAFFIC_SOURCE = 'user_signed_up_from_traffic_source',
  USER_FOLLOW_REDIRECT_TO_PAYMENT = 'user_follow_redirect_to_payment',
}
